export default __webpack_public_path__ + "static/media/Purple-BG-Middle.9b81a321.svg";